// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes widgetWrapper-module_complexFadeIn__iEX7J {
    0%, 30% {
        opacity: 0;
    }
    80% {
        opacity: 0.3;
    }
    100% {
        opacity: 0.96;
    }
}

.widgetWrapper-module_overlayContainer__CGQt6 {
    align-items: center;
    background: var(--white);
    opacity: 0;
    bottom: 0;
    display: block;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: var(--zindex-loader-layout);
    animation: widgetWrapper-module_complexFadeIn__iEX7J 1000ms forwards;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgetWrapper.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,UAAU;IACV,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,oCAAoC;IACpC,oEAAwC;AAC5C","sourcesContent":["@keyframes complexFadeIn {\n    0%, 30% {\n        opacity: 0;\n    }\n    80% {\n        opacity: 0.3;\n    }\n    100% {\n        opacity: 0.96;\n    }\n}\n\n.overlayContainer {\n    align-items: center;\n    background: var(--white);\n    opacity: 0;\n    bottom: 0;\n    display: block;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: var(--zindex-loader-layout);\n    animation: complexFadeIn 1000ms forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayContainer": `widgetWrapper-module_overlayContainer__CGQt6`,
	"complexFadeIn": `widgetWrapper-module_complexFadeIn__iEX7J`
};
export default ___CSS_LOADER_EXPORT___;
